<!-- TopBar -->
<nav class="navbar navbar-expand navbar-light bg-navbar topbar mb-4 static-top" *ngIf="loggedIn()">
  <button (click)="visibleSidebar = true" class="btn btn-link rounded-circle mr-3">
    <i class="fa fa-bars" style="color: #1A355E;"></i>
  </button>
  <h5 class="ml-2 d-none d-lg-inline font-weight-bold text-white">
    <a *ngIf="getRoleId()==1" routerLink="/portal">
      <img src="../../assets/img/logo/logo-bg.png" style="width: 70%;">
    </a>
    <a *ngIf="getRoleId()==2" routerLink="/contract">
      <img src="../../assets/img/logo/logo-bg.png" style="width: 70%;">
    </a>
  </h5>
  <ul class="navbar-nav ml-auto">

    <li class="nav-item dropdown no-arrow">
      <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fas fa-cogs fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span class="ml-2 d-none d-lg-inline font-weight-bold" style="color:#1A355E;">Ayarlar</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">

        <a *ngIf="getRoleId()==1" class="dropdown-item d-flex align-items-center" style="color:#1A355E;"
          routerLink="/portal">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Portaller</span>
          </div>
        </a>

        <a *ngIf="getRoleId()==1" class="dropdown-item d-flex align-items-center" style="color:#1A355E;"
          routerLink="/nbs-user">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Kullanıcılar</span>
          </div>
        </a>



        <a *ngIf="getRoleId()==1" class="dropdown-item d-flex align-items-center" style="color:#1A355E;"
          routerLink="/contract-type">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Abonelik Tipleri</span>
          </div>
        </a>

        <a *ngIf="getRoleId()==1" class="dropdown-item d-flex align-items-center" style="color:#1A355E;"
          routerLink="/device-model">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Cihaz Modelleri</span>
          </div>
        </a>

        <!-- <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/dealer">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Bayiler</span>
          </div>
        </a> -->

      </div>
    </li>

    <li class="nav-item dropdown no-arrow">
      <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fas fa-pen fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span class="ml-2 d-none d-lg-inline font-weight-bold" style="color:#1A355E;">Tanımlar</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">


        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/contract">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Abonelikler</span>
          </div>
        </a>

        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/logo-project">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Projeler</span>
          </div>
        </a>

        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/logo-customer">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Müşteriler</span>
          </div>
        </a>

        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/logo-service">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Hizmetler</span>
          </div>
        </a>

        <a *ngIf="getRoleId()==1" class="dropdown-item d-flex align-items-center" style="color:#1A355E;"
          routerLink="/terminal">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Terminaller</span>
          </div>
        </a>

      </div>
    </li>

    <li class="nav-item dropdown no-arrow">
      <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fas fa-briefcase fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span class="ml-2 d-none d-lg-inline font-weight-bold" style="color:#1A355E;">Hareketler</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">
        <a *ngIf="getRoleId()==1" class="dropdown-item d-flex align-items-center" style="color:#1A355E;"
          routerLink="/customer-terminal">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Müşteri - Terminal Ataması</span>
          </div>
        </a>

        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/movement">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Hareket Tablosu</span>
          </div>
        </a>
      </div>
    </li>


    <li class="nav-item dropdown no-arrow">
      <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fas fa-tachometer-alt fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span class="ml-2 d-none d-lg-inline font-weight-bold" style="color:#1A355E;">Raporlar</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">
        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/general-report">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Müşteri - Terminal Raporu</span>
          </div>
        </a>
        <a class="dropdown-item d-flex align-items-center" style="color:#1A355E;" routerLink="/dealer-report">
          <div class="mr-3">
            <div class="icon-circle bg-danger">
            </div>
          </div>
          <div>
            <span class="font-weight-bold">Bayi Raporu</span>
          </div>
        </a>
      </div>

    </li>

    <div class="topbar-divider d-none d-sm-block"></div>

    <li class="nav-item dropdown no-arrow">
      <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fas fa-user fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span class="ml-2 d-none d-lg-inline font-weight-bold" style="color:#1A355E;"> {{loginUserName}} </span>
      </a>
      <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in">
        <a class="dropdown-item">
          <button type="button" class="btn btn-success" (click)="showModal()" style="width: 100%;">Şifre
            Değiştir</button>
        </a>
        <a class="dropdown-item">
          <button type="button" class="btn btn-danger" (click)="logOut()" style="width: 100%;">Çıkış</button>
        </a>
      </div>
    </li>


  </ul>
</nav>
<!-- Topbar -->

<p-sidebar [(visible)]="visibleSidebar" [showCloseIcon]="false" [style]="{width:'16em'}" *ngIf="loggedIn()">
  <!-- Sidebar -->
  <ul class="navbar-nav sidebar sidebar-light accordion" id="accordionSidebar">
    <a class="sidebar-brand d-flex align-items-center justify-content-center">
      <div class="sidebar-brand-text mx-3 font-weight-bold text-white">
        <img src="../../assets/img/logo/logo-bg.png" style="width: 100%;">
      </div>
    </a>

    <li class="nav-item active">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseBootstrap"
        aria-expanded="true" aria-controls="collapseBootstrap">
        <i class="fas fa-cogs fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span style="color: #1A355E;">Ayarlar</span>
      </a>
      <div id="collapseBootstrap" class="collapse" aria-labelledby="headingBootstrap" data-parent="#accordionSidebar">
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header" style="color: #1A355E;">Ayarlar</h6>
          <a *ngIf="getRoleId()==1" class="collapse-item" style="color:#1A355E;" routerLink="/portal"
            (click)="visibleSidebar = false">Portaller</a>
          <a *ngIf="getRoleId()==1" class="collapse-item" style="color:#1A355E;" routerLink="/nbs-user"
            (click)="visibleSidebar = false">Kullanıcılar</a>

          <a *ngIf="getRoleId()==1" class="collapse-item" style="color:#1A355E;" routerLink="/contract-type"
            (click)="visibleSidebar = false">Abonelik Tipleri</a>
          <a *ngIf="getRoleId()==1" class="collapse-item" style="color:#1A355E;" routerLink="/device-model"
            (click)="visibleSidebar = false">Cihaz Modelleri</a>
          <!-- <a class="collapse-item" style="color:#1A355E;" routerLink="/dealer"
            (click)="visibleSidebar = false">Bayiler</a> -->
        </div>
      </div>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item  active">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseForm" aria-expanded="true"
        aria-controls="collapseForm">
        <i class="fas fa-pen fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span style="color: #1A355E;">Tanımlar</span>
      </a>
      <div id="collapseForm" class="collapse" aria-labelledby="headingForm" data-parent="#accordionSidebar">
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header" style="color: #1A355E;">Tanımlar</h6>
          <a class="collapse-item" style="color:#1A355E;" routerLink="/contract"
            (click)="visibleSidebar = false">Abonelikler</a>
          <a class="collapse-item" style="color:#1A355E;" routerLink="/logo-project"
            (click)="visibleSidebar = false">Projeler</a>
          <a class="collapse-item" style="color:#1A355E;" routerLink="/logo-customer"
            (click)="visibleSidebar = false">Müşteriler</a>
          <a class="collapse-item" style="color:#1A355E;" routerLink="/logo-service"
            (click)="visibleSidebar = false">Hizmetler</a>
          <a *ngIf="getRoleId()==1" class="collapse-item" style="color:#1A355E;" routerLink="/terminal"
            (click)="visibleSidebar = false">Terminaller</a>
        </div>
      </div>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item active">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTable" aria-expanded="true"
        aria-controls="collapseTable">
        <i class="fas fa-briefcase fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span style="color: #1A355E;">Hareketler</span>
      </a>
      <div id="collapseTable" class="collapse" aria-labelledby="headingTable" data-parent="#accordionSidebar">
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header" style="color: #1A355E;">Hareketler</h6>
          <a *ngIf="getRoleId()==1" class="collapse-item" style="color:#1A355E;" routerLink="/customer-terminal"
            (click)="visibleSidebar = false">Müşteri - Terminal
            Ataması</a>
          <a class="collapse-item" style="color:#1A355E;" routerLink="/movement"
            (click)="visibleSidebar = false">Hareket Tablosu</a>
        </div>
      </div>
    </li>
    <hr class="sidebar-divider">
    <li class="nav-item active">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseDashboard"
        aria-expanded="true" aria-controls="collapseDashboard">
        <i class="fas fa-tachometer-alt fa-sm fa-fw mr-2" style="color: #1A355E;"></i>
        <span>Raporlar</span>
      </a>
      <div id="collapseDashboard" class="collapse" aria-labelledby="headingTable" data-parent="#accordionSidebar">
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header">Raporlar</h6>
          <a class="collapse-item" routerLink="/general-report" (click)="visibleSidebar = false">Müşteri - Terminal</a>
          <a class="collapse-item" routerLink="/dealer-report" (click)="visibleSidebar = false">Bayi Raporu</a>
        </div>
      </div>

    </li>
    <hr class="sidebar-divider">

  </ul>
  <!-- Sidebar -->
</p-sidebar>


<p-dialog header="ŞİFRE DEĞİŞTİR" [(visible)]="displayModal" [modal]="true" [style]="{width: '50vw'}"
  [baseZIndex]="10000" [draggable]="false" [resizable]="false">

  <form class="user" [formGroup]="form">
    <div class="form-group">
      <input type="password" class="form-control" formControlName="oldPassword" placeholder="Mevcut Şifrenizi Giriniz.."
        autofocus>
    </div>
    <div class="form-group">
      <input type="password" class="form-control" formControlName="newPassword" placeholder="Yeni Şifrenizi Giriniz..">
    </div>
  </form>

  <ng-template pTemplate="footer">
    <p-button (click)="displayModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
    <p-button (click)="changePassword()" label="Kaydet" styleClass="p-button-success" [disabled]="form.invalid">
    </p-button>
  </ng-template>
</p-dialog>